import type { ReactNode } from 'react';
import { UnitsModuleContext, type UnitsModule } from './module-context';

export function UnitsProvider({ module, children }: { module: UnitsModule; children: ReactNode }) {
  return <UnitsModuleContext.Provider value={module}>{children}</UnitsModuleContext.Provider>;
}
